module.exports = __webpack_public_path__ + "static/media/logo_wecare_header.427c8557.png";